import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Phase-1 white-label hook.
 * Resolves the org slug from `?org=<slug>` querystring or subdomain, then loads
 * branding (app name, colors, headings, support email, logo) from
 * `GET /api/branding?slug=<slug>`. Falls back gracefully to the Default org.
 *
 * Only the public pages (landing, login selector, variant logins) need this.
 * Existing dashboards keep their static styling as required.
 */
export function useBranding(explicitSlug = null) {
  const [branding, setBranding] = useState(null);
  useEffect(() => {
    let slug = explicitSlug;
    if (!slug && typeof window !== "undefined") {
      const qs = new URLSearchParams(window.location.search).get("org");
      if (qs) slug = qs;
      // Path-based routing: /o/<slug>/...
      if (!slug) {
        const m = window.location.pathname.match(/^\/o\/([a-z0-9-]+)(\/|$)/i);
        if (m) slug = m[1];
      }
      if (!slug) {
        const host = window.location.hostname.split(".");
        // subdomain form: <slug>.ambassadoros.com — ignore preview/emergent hosts
        if (host.length > 2 && !host[0].includes("preview") && !host[0].includes("brand-ambassadors")) {
          slug = host[0];
        }
      }
    }
    api.get(`/branding${slug ? `?slug=${encodeURIComponent(slug)}` : ""}`)
      .then(({ data }) => {
        setBranding(data);
        if (data.app_name && typeof document !== "undefined") {
          document.title = data.app_name;
        }
        if (data.favicon_url && typeof document !== "undefined") {
          const link = document.querySelector("link[rel='icon']") || document.createElement("link");
          link.rel = "icon";
          link.href = data.favicon_url;
          document.head.appendChild(link);
        }
      })
      .catch(() => setBranding(null));
  }, [explicitSlug]);
  return branding;
}
